export class AppSettings {
    public title: string = "Wells P&A Lookback";
    public version: string = "";
    public openAccess: boolean = true;
    public showNav: boolean = true;
    public showFooter: boolean = true;
    public supportLink: string = "";
    public user: any = null;
    public roles: any = null;
}
